export default function nameValidation(name) {
  const valid = name.length > 0 && !!name.trim() && name[0] !== ' ';
  return valid;
}
